import React from "react";

function BS4_JS_Collapse() {
  return (
    <div>
      <h1>BS4_JS_Collapse Component</h1>
      <p>This is the BS4_JS_Collapse tutorial page content.</p>
    </div>
  );
}

export default BS4_JS_Collapse;
